import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';

export const getDebtsHandler = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/debts', async () => {
        const session = MockServiceWorker.getMockedSession();
        const debts = [];
        for (let i = 0; i < session.numberOfDebts; i++) {
            debts.push({
                internalId: '' + i,
                creditorName: 'Banknavn',
                currentBalance: {
                    amount: (i + 1) * 10000,
                    currency: 'NOK',
                },
                nominalInterestRate: 15.5,
                accountType: 'REPAYMENT_LOANS',
                tenor: 24,
                nonSelectable: false,
            });
        }

        return HttpResponse.json({ debts });
    }),
];
